import { Controller } from "@hotwired/stimulus"

// Keep native details/summary semantics; animate only the revealed height.
export default class extends Controller {
  static targets = ["summary"]
  static values = {
    duration: { type: Number, default: 240 },
    easing: { type: String, default: "cubic-bezier(.2, .7, .2, 1)" }
  }

  connect() {
    this.expanded = this.element.open
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.motionChanged = () => { if (this.motion.matches) this.finish() }
    this.motion.addEventListener("change", this.motionChanged)
  }

  toggle(event) {
    event.preventDefault()
    const startHeight = this.element.getBoundingClientRect().height
    this.stop()
    this.expanded = !this.expanded
    if (this.motion.matches || !this.element.animate) return this.finish()

    // Measure the natural final box so padded disclosures settle without a jump.
    this.element.open = this.expanded
    const endHeight = this.element.getBoundingClientRect().height
    this.element.open = true
    this.element.classList.add("is-animating")
    this.element.classList.toggle("is-closing", !this.expanded)
    this.animation = this.element.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: this.durationValue, easing: this.easingValue, fill: "both" }
    )
    this.animation.onfinish = () => this.finish()
  }

  stop() {
    if (this.animation) {
      this.animation.onfinish = null
      this.animation.cancel()
      this.animation = null
    }
    this.element.classList.remove("is-animating", "is-closing")
  }

  finish() {
    this.element.open = this.expanded
    this.stop()
  }

  disconnect() {
    this.motion.removeEventListener("change", this.motionChanged)
    this.finish()
  }
}
